import * as types from "../../mutation-types.js";
import http from "@service/http";
import { tokenCall, restCall } from "@service/adapter";
import util from "@common/utils/util";
import Constant from "@/Constant";
import { storage } from "@common/utils/util.js";

const TASK_INFO = "TASK_INFO";

/**
 * 登陆-注册STORE
 */
export default {
  state: {
    taskInfo: "",
  },
  actions: {
    pageRecNotes({ commit }, data) {
      return tokenCall("/mxoa/projectRecord/pageNotes", data, "post")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    addRecNote({ commit }, data) {
      return tokenCall("/mxoa/projectRecord/addNote", data, "post")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // 变更状态
    changeRecState({ commit }, data) {
      return tokenCall("/mxoa/projectRecord/updateRecordState", data, "post")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取法人信息
    getCompanyLegal({ commit }, data) {
      return tokenCall(
        "/mxoa/legalAuth/pageCompanyLegal",
        { pageNo: 1, pageSize: 100 },
        "post"
      )
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    // getUserKey
    getCates({ commit }, data) {
      return tokenCall(
        Constant.tokenCallUrl + "/mxoa/wf/cate/getCates",
        data,
        "get"
      )
        .then((result) => {
          if ((result.code = 200)) {
            return Promise.resolve(result.data);
          } else {
            return Promise.reject(result.message || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取经销商列表
    getPageDealers({ commit }, data) {
      return tokenCall("/mxoa/sm/user/pageDealers", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //工程续备案提交/mxoa/projectRecord/commit
    projectreCommit({ commit }, data) {
      let url = data.url,
        comData = data.data;
      return tokenCall(url, comData, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //删除工程备案
    removeProject({ commit }, data) {
      return tokenCall("/mxoa/projectRecord/remove", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //删除保护区备案
    removeProtect({ commit }, data) {
      return tokenCall("/mxoa/protect/remove", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取流程列表
    getFlowList({ commit }, data) {
      return tokenCall("/mxoa/flow/getFlowList", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取流程日志列表
    getFlowLog({ commit }, data) {
      return tokenCall("/mxoa/flow/getFlowLog", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取待办列表
    getPageTask({ commit }, data) {
      return tokenCall("/mxoa/flow/pageTask", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取待办数量
    getTaskCount({ commit }, data) {
      return tokenCall("/mxoa/flow/getTaskCount", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject((res && res.message) || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取初始化备案产品信息
    getProjectProds({ commit }, data) {
      return tokenCall("/mxoa/projectRecord/getProjectProds", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取初始化备案产品信息
    getProjectProdsByArea({ commit }, data) {
      return tokenCall("/mxoa/projectRecord/getProjectProds2", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取用户信息
    getUserInfo({ commit }, data) {
      return tokenCall("/mxoa/sm/user/info", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取部门树结构数据
    getDepartSubs({ commit }, data) {
      return tokenCall("/mxoa/sm/depart/getDepartSubs", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取部门用户树结构数据
    getDepartUsers({ commit }, data) {
      return tokenCall("/mxoa/sm/depart/getDepartUsers", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取下一环节
    getNextTache({ commit }, data) {
      return tokenCall("/mxoa/flow/getNextTache", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //获取可以回退的任务
    getCanBackTo({ commit }, data) {
      return tokenCall("/mxoa/flow/getCanBackTo", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //任务处理
    finishTask({ commit }, data) {
      return tokenCall("/mxoa/flow/finishTask", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //任务转派/flow/moveTask
    moveTask({ commit }, data) {
      return tokenCall("/mxoa/flow/moveTask", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //任务回退
    backDirect({ commit }, data) {
      return tokenCall("/mxoa/flow/backDirect", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //取消备案流程
    cancelProcess({ commit }, data) {
      return tokenCall("/mxoa/flow/cancelProcess", data, "get")
        .then((res) => {
          if (res.code == 200) {
            return Promise.resolve(res);
          } else {
            return Promise.reject(res || "获取数据失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //保存选中的tast
    saveTask({ commit }, data) {
      commit(TASK_INFO, data);
    },
    clearTask({ commit }) {
      commit(TASK_INFO, 1);
    },
  },
  mutations: {
    TASK_INFO(state, data) {
      if (data == 1) {
        state.taskInfo = "";
        storage.local.remove("taskInfo");
        return;
      }
      state.taskInfo = data;
      storage.local.set("taskInfo", data);
    },
  },
  getters: {
    taskInfo: (state) => {
      return state.taskInfo || storage.local.get("taskInfo");
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/agency/agencyCom.js